import React, { useState, useEffect } from 'react';
import { Modal, Button, Dropdown, Menu, Tooltip } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import moment from 'moment';

import Home from 'pages/home';
import SubmitFeedbackModal from 'components/submitFeedbackModal';

import CESExcel from 'data/CES.xlsx';
import CMFExcel from 'data/CMF.xlsx';

const Footer = () => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [showInitialInstructions, setShowInitialInstructions] = useState(true);
  const [showInstructionsCheckbox, setShowInstructionsCheckbox] =
    useState(false);

  const instructions = (
    <Modal
      width={1000}
      title={
        window.location != window.parent.location
          ? 'IES Spectral Calculator'
          : 'PNNL Applied Lighting Spectral Calculator'
      }
      visible={
        showInstructions ||
        (showInitialInstructions &&
          !sessionStorage.getItem('hide-instructions'))
      }
      onCancel={() => {
        setShowInstructions(false);
        setShowInitialInstructions(false);
        sessionStorage.setItem('hide-instructions', true);
      }}
      footer={
        <div>
          <div>
            <strong>
              Note: If you want to access instructions again in future, please
              refer to the <b>User Manual</b> link in the footer.
            </strong>
            <br />
          </div>
          <Button
            type='primary'
            key='close'
            onClick={() => {
              setShowInstructions(false);
              setShowInitialInstructions(false);
              sessionStorage.setItem('hide-instructions', true);
            }}
          >
            Close
          </Button>
        </div>
      }
    >
      <Home />
    </Modal>
  );

  const calculationDataFilesMenu = (
    <Menu className='calculation-data-files-dropdown-menu'>
      <Menu.Item>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href={CESExcel}
          download='CES.xlsx'
        >
          99 CES (Excel)
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href={CMFExcel}
          download='CMF.xlsx'
        >
          6 CMFs (Excel)
        </a>
      </Menu.Item>
      <Menu.Item>
        <Tooltip placement='top' title='Coming soon.'>
          {/* <a target='_blank' rel='noopener noreferrer' href=''> */}
          The C code
          {/* </a> */}
        </Tooltip>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className='footer'>
      {instructions}
      <div className='footer-left'>
        {window.location != window.parent.location ? (
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.ies.org/'
          >
            <img
              alt='app-logo'
              className='footer-picture'
              src={`${process.env.PUBLIC_URL}/images/ies-logo.jpg`}
            />
          </a>
        ) : (
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.pnnl.gov'
          >
            <img
              alt='app-logo'
              className='footer-picture'
              src={`${process.env.PUBLIC_URL}/images/pnnl-logo.png`}
            />
          </a>
        )}

        <div>
          {/* <div style={{ fontSize: '15px' }}>
            ©1906-{moment().year()} Illuminating Engineering Society
          </div> */}
          <div className='footer-links'>
            {/* <a
              style={{ marginLeft: 0 }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.ies.org/terms-of-use/"
            >
              Terms of Use
            </a>
            | */}
          </div>
        </div>
      </div>
      <div className='footer-links right-links'>
        <div>
          <span onClick={() => setShowInstructions(true)}>
            Spectral Calculator User Manual
          </span>
          |
          <span onClick={() => setShowFeedbackModal(true)}>
            Provide Feedback
          </span>
          |
          <Dropdown overlay={calculationDataFilesMenu}>
            <a onClick={(e) => e.preventDefault()}>
              Calculation Data Files <DownOutlined className='dropdown-icon' />
            </a>
          </Dropdown>
          |
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.pnnl.gov/security-privacy'
          >
            Security & Privacy Policy
          </a>
        </div>
        <div>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://store.ies.org/product/tm-30-20-ies-method-for-evaluating-light-source-color-rendition/'
          >
            ANSI/IES TM-30-20
          </a>
          |
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.ies.org/about-outreach/position-statements/ps-11-18-ies-position-on-tm-30-18-ies-method-for-evaluating-light-source-color-rendition/'
          >
            IES PS-11-18
          </a>
          |
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.energy.gov/eere/ssl/articles/tutorial-background-and-guidance-using-ansiies-tm-30-method-evaluating-light'
          >
            TM-30 Tutorial
          </a>
          |
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.osapublishing.org/oe/fulltext.cfm?uri=oe-23-12-15888&id=320167'
          >
            TM-30 Development
          </a>
        </div>
        <div>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://cie.co.at/publications/cie-system-metrology-optical-radiation-iprgc-influenced-responses-light-0'
          >
            CIE S0216:2018
          </a>
          |
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://cie.co.at/publications/what-document-and-report-studies-iprgc-influenced-responses-light'
          >
            CIE TN011:2020
          </a>
        </div>
        <SubmitFeedbackModal
          showFeedbackModal={showFeedbackModal}
          setShowFeedbackModal={setShowFeedbackModal}
        />
      </div>
    </div>
  );
};

export default Footer;
